;(function ($) {

	$(document).ready(function(){
		$('#mobile-menu').click(function(){
			$(this).toggleClass('open');
            $('.mobile-menu').slideToggle();
			$('.home-logo').toggleClass('open-menu');
        });
	});


	$(window).load(function(){


	});


	$(window).resize(function(){


	});

	$(window).scroll(function (event) {
		var scroll = $(window).scrollTop();

		if( $('.nav-desktop').css('display')=='none') {
			if(scroll > 34){
				$('header').addClass('scroll');
			} else {
				$('header').removeClass('scroll');
			}
   		} else {
			if(scroll > 84){
				$('header').addClass('scroll');
			} else {
				$('header').removeClass('scroll');
			}
		}

	});


})(jQuery);
